export const DboModule = {
    namespaced: true,
    state: () => ({
        step: 'start',
        phone: ''
    }),
    mutations: {
        SET_STEP(state, val) {
            state.step = val;
        },
        SET_PHONE(state, val) {
            state.phone = val;
        }
    },
};
